import React, { useLayoutEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useGlobalState } from '../stateProvider/StateProvider';
import Customers from '../pages/Customers';
import User from '../pages/user';
import Visitors from '../pages/Visitors';
import VisitorsReport from '../pages/VisitorsReport';
import Visitor from '../pages/visitor';
import Settings from '../pages/settings/Settings';
import Transaction from '../pages/reporting/Transaction';
import Invoice from '../pages/reporting/Invoice';
import Account from '../pages/account/Account';
import WashClub from '../pages/washClub/WashClub';
import Codes from '../pages/codes/Codes';
import DealsPage from '../pages/mobile/DealsPage';
import PromoCodesPage from '../pages/mobile/PromoCodesPage';
import PushNotificationsPage from '../pages/mobile/PushNotificationsPage';
import LoyaltyPointsPage from '../pages/mobile/LoyaltyPointsPage';
import LoyaltyPointAwardsPage from '../pages/mobile/LoyaltyPointAwardsPage';
import ReferralProgramPage from '../pages/mobile/ReferralProgramPage';
import BirthdayClubPage from '../pages/mobile/BirthdayClubPage';
import AirPayPage from '../pages/mobile/AirPayPage';
import GiftEmailPage from '../pages/mobile/GiftEmailPage';
import MobileLocationsPage from '../pages/mobile/LocationsPage';
import MobileSettingsPage from '../pages/mobile/SettingsPage';
import SurveysPage from '../pages/mobile/SurveysPage';
import Feedback from '../pages/Feedback';
import Updates from '../pages/Updates';
import ExpressPass from '../pages/expressPass/ExpressPass';
import SalesReport from '../pages/reporting/sales/SalesReport';
import MobileAppReport from '../pages/reporting/mobileApp/MobileAppReport';
import ExpressPassReport from '../pages/reporting/expressPass/ExpressPassReport';
import CodesReport from '../pages/reporting/codes/CodesReport';
import Locations from '../pages/Locations';
import Fulfillment from '../pages/fulfillment/Fulfillment';
import KioskBundles from '../pages/codes/KioskBundles';
import LoyaltyUser from '../pages/user/LoyaltyUser';
import LoyaltyMember from '../pages/user/LoyaltyAccount/LoyaltyMember';
import KioskItemsPage from '../pages/products/KioskItemsPage';
import MobileAppPage from '../pages/products/MobileAppPage';
import PlateReadAwardsPage from '../pages/products/PlateReadAwardsPage';
import AppCreditPage from '../pages/products/AppCreditPage';
import Hamilton from '../pages/hamilton';
import Subscription from '../pages/reporting/subscription/Index';
import UserEventLog from '../pages/UserEventLog';
import Prorate from '../pages/Prorate';
import MediaLookUp from '../pages/media/MediaLookUp';
import LicensePlateReads from '../pages/plateReads/LicensePlateReads';
import Marketing from '../pages/Marketing';
import AllowedFeatures, { featureNames } from './AllowedFeatures';
import KioskErrorResponses from '../pages/reporting/KioskErrorResponses';
import ReceiptCodes from '../pages/codes/ReceiptCodes';
import LicensePlateAwards from '../pages/plateReads/LicensePlateAwards';


const AppRouter = () => {
    const { state: {
        active_user
    } } = useGlobalState();

    return (
        <Routes>
            <Route path={'/customers'} element={<Customers />} />

            <Route path={'/locations'} element={<Locations />} />

                <Route path={'/user/:guid'} element={<User />} />
                <Route path={'/loyaltyUser/:loyaltyAccountId'} element={<LoyaltyUser />} />
                <Route path={'/loyaltyMember/:loyaltyMemberId'} element={<LoyaltyMember />} />

                <Route path={'/visitors'} element={<Visitors />} />
                <Route path={'/visitors/report'} element={<VisitorsReport />} />
                <Route path={'/visitor/:plate'} element={<Visitor />} />                

            <Route index path={'/mediaLookup'} element={<MediaLookUp />} />

            <Route index path={'/products/kioskItems'} element={<KioskItemsPage />} />
            <Route index path={'/products/mobile'} element={<MobileAppPage />} />
            <Route index path={'/products/plateReadAwards'} element={<PlateReadAwardsPage />} />
            <Route index path={'/products/appCredit'} element={<AppCreditPage />} />

            <Route index path={'/awards'} element={<LicensePlateAwards />} />

            <Route index path={'/washClub'} element={<WashClub />} />

            <Route index path={'/expressPass'} element={<ExpressPass />} />

            <Route index path={'/SingleUseCodes'} element={<Codes />} />

            <Route index path={'/ReceiptCodes'} element = {<ReceiptCodes />} />

            <Route index path={'/mobile/deals'} element={<DealsPage />} />
            <Route index path={'/mobile/promoCodes'} element={<PromoCodesPage />} />
            <Route index path={'/mobile/pushNotifications'} element={<PushNotificationsPage />} />
            <Route index path={'/mobile/loyaltyPoints'} element={<LoyaltyPointsPage />} />
            <Route index path={'/mobile/loyaltyPointAwards'} element={<LoyaltyPointAwardsPage />} />
            <Route index path={'/mobile/referralProgram'} element={<ReferralProgramPage />} />
            <Route index path={'/mobile/birthdayClub'} element={<BirthdayClubPage />} />
            <Route index path={'/mobile/airPay'} element={<AirPayPage />} />
            <Route index path={'/mobile/giftEmailDetails'} element={<GiftEmailPage />} />
            <Route index path={'/mobile/locations'} element={<MobileLocationsPage />} />
            <Route index path={'/mobile/settings'} element={<MobileSettingsPage />} />
            <Route index path={'/mobile/surveys'} element={<SurveysPage />} />

            <Route index path={'/fulfillment'} element={<Fulfillment />} />

            <Route index path={'/kioskBundles'} element={<KioskBundles />} />


            <Route index path={'/settings'} element={<Settings />} />

            <Route index path={'/audit/:guid'} element={<UserEventLog />} />

            <Route index path={'/myAccount'} element={<Account />} />

            <Route index path={'/hamilton'} element={<Hamilton />} />

            <Route index path={'/updates'} element={<Updates />} />

            <Route index path={'/feedBack'} element={<Feedback />} />

            <Route index path={'/prorate'} element={<Prorate />} />

                {/* Reporting */}
                <Route path='/reporting/Sales' element={<SalesReport />} />
                <Route path='/reporting/MobileApp' element={<MobileAppReport />} />
                <Route path='/reporting/ExpressPass' element={<ExpressPassReport />} />
                <Route path='/reporting/Codes' element={<CodesReport />} />
                <Route path='/reporting/Subscriptions' element={<Subscription />} />
                <Route path='/reporting/KioskErrorResponses' element={<KioskErrorResponses />} />
                

                <Route path='/reporting/Sales/Invoice/:invoiceId' element={<Invoice />} />
                <Route path='/reporting/Sales/Transaction/:transactionId' element={<Transaction />} />

                <Route path='/media/mediaLookup' element={<MediaLookUp />} />
                <Route path='/media/LicensePlateReads' element={<LicensePlateReads />} />

            {/* <Route path='*' exact={true} element={<FourOhFour />} /> */}

        </Routes>
    );
}

export default AppRouter;
